// =====================================
//
//   messageBox Modal
//   Author: Gray
//   createtime: 2016 / 02 / 22
//   updatetime: 2016 / 02 / 22
//
// =====================================

window.InifECApp.directive('messageBox', ['$rootScope', '$stateParams', '$timeout', '$ngModal', '$state',
    function($rootScope, $stateParams, $timeout, $ngModal, $state) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var openModal = function() {

                $ngModal.openModal("message-box");
            }

            var closeModal = function() {

                $ngModal.closeModal("message-box");
            }

            var cancel = function() {

                closeModal();
                $scope.callback && $scope.callback();
            }

            var finishIdentify = function() {

                $state.go(window.STATES.HOME);
                closeModal();
                $rootScope.$broadcast("LOGIN_SUCCESS");
            }


            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_EMAIL_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "MAIL";
                if(data) {
                    $scope.callback = data.callback;
                }
                openModal();
            });

            $scope.$on("OPEN_MAIL_IDENTIFY_MODAL", function(event, data) {
                $scope.viewType = "IDENTIFY";
                if(data) {
                    $scope.callback = data.callback;
                }
                openModal();
            });

            $scope.$on("OPEN_SIMPLE_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "SIMPLE";
                $scope.title = data.title;
                $scope.desc = data.desc;
                if(data) {
                    $scope.callback = data.callback;
                }
                openModal();
            });

            $scope.$on("OPEN_ERROR_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "ERROR";
                $scope.title = data.title;
                $scope.desc = data.desc;
                if(data) {
                    $scope.callback = data.callback;
                }
                openModal();
            });

            $scope.$on("OPEN_SUCCESS_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "SUCCESS";
                $scope.title = data.title;
                $scope.desc = data.desc;
                if(data) {
                    $scope.callback = data.callback;
                }
                openModal();
            });
                
            /*==========================
                Members
            ==========================*/

            $scope.viewType = "SIMPLE";
            $scope.title = "";
            $scope.desc = "";
            $scope.INIFEC_URL = INIFEC_URL;
            $scope.callback;

            /*==========================
                Methods
            ==========================*/
            $scope.cancel = cancel;
            $scope.finishIdentify = finishIdentify;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/message_box.html';
        _dir.controller = controller;

        return _dir;
}]);